














import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../CardTitle.vue";
import { DocNominaResponsabileInfo } from "../../_models/docNominaResponsabileInfo";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { router } from "../../_router";
import { DocAttestatoFinale } from "../../_models/docAttestatoFinale";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  components: {
    CardTitle
  }
})
export default class AttestatoFinaleTirEstivoReview extends Vue {
  @Prop() idStatoDoc!: number;
  @Prop() ruoloUtente!: number;
  @Prop() docInfo!: DocAttestatoFinale;
  private elements: DocAttestatoFinale;
  private gruppoUnoArray: string[];
  private gruppoDueArray: string[];
  private gruppoTreArray: string[];
  private gruppoQuattroArray: string[];
  private gruppoCinqueArray: string[];
  private gruppoSeiArray: string[];
  private gruppoSetteArray: string[];
  private gruppoOttoArray: string[];
  private gruppoNoveArray: string[];
  private gruppoDieciArray: string[];

  constructor() {
    super();
    this.gruppoUnoArray = [];
    this.gruppoDueArray = [];
    this.gruppoTreArray = [];
    this.gruppoQuattroArray = [];
    this.gruppoCinqueArray = [];
    this.gruppoSeiArray = [];
    this.gruppoSetteArray = [];
    this.gruppoOttoArray = [];
    this.gruppoNoveArray = [];
    this.gruppoDieciArray = [];
    this.elements = {
      idAttestatoFinale: this.docInfo.idAttestatoFinale,
      dataAttestato: this.docInfo.dataAttestato,
      luogoAttestato: this.docInfo.luogoAttestato,
      dataInizioPeriodo: this.docInfo.dataInizioPeriodo,
      dataFinePeriodo: this.docInfo.dataFinePeriodo,
      totaleOre: this.docInfo.totaleOre,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      allievo: this.docInfo.allievo,
      classeAllievo: this.docInfo.classeAllievo,
      noteAggiuntive: this.docInfo.noteAggiuntive,
      gruppoUno: this.docInfo.gruppoUno,
      gruppoDue: this.docInfo.gruppoDue,
      gruppoTre: this.docInfo.gruppoTre,
      gruppoQuattro: this.docInfo.gruppoQuattro,
      gruppoCinque: this.docInfo.gruppoCinque,
      gruppoSei: this.docInfo.gruppoSei,
      gruppoSette: this.docInfo.gruppoSette,
      gruppoOtto: this.docInfo.gruppoOtto,
      gruppoNove: this.docInfo.gruppoNove,
      gruppoDieci: this.docInfo.gruppoDieci,
      firmaTutorAzienda: this.docInfo.firmaTutorAzienda,
      tipoAttivita: this.docInfo.tipoAttivita,
      idRichiesta: this.docInfo.idRichiesta,
      numeroProtocollo: this.docInfo.numeroProtocollo,
      dataProtocollo: this.docInfo.dataProtocollo,
      idTutorAzienda: this.docInfo.idTutorAzienda,
      tutorAzienda: this.docInfo.tutorAzienda,
      tutorFormativo: this.docInfo.tutorFormativo
    };
  }

  createDoc() {
    var dd = {
      pageSize: "A4",
      content: [
        {
          text: "TIROCINIO ESTIVO",
          alignment: "center",
          bold: true,
          fontSize: 10
        },
        {
          text: "Ai sensi della DGR 19-4575 del 16/1/2017",
          alignment: "center",
          style: "bodyText"
        },
        {
          text: "ATTESTATO FINALE DEL PERCORSO FORMATIVO",
          bold: true,
          alignment: "center",
          margin: [0, 5, 0, 0],
          fontSize: 10
        },
        {
          text:
            "Allegato alla Convenzione Prot. n " +
            this.elements.numeroProtocollo +
            " del " +
            this.elements.dataProtocollo,
          style: "bodyText",
          margin: [0, 10, 0, 0]
        },
        {
          text:
            "Al termine del tirocinio Estivo il Soggetto Ospitante, " +
            this.elements.denominazioneAzienda +
            ", per consentire la validazione del Percorso Formativo da parte del Soggetto Promotore attraverso il suo Tutor esterno " +
            this.elements.tutorFormativo,
          style: "bodyText",
          margin: [0, 5, 0, 5]
        },
        {
          text: "CERTIFICA CHE " + this.elements.allievo,
          alignment: "center",
          bold: true,
          margin: [0, 0, 0, 5],
          fontSize: 10
        },
        {
          text:
            "studente/ssa dell’ ISTITUTO di ISTRUZIONE SUPERIORE “G. VALLAURI”,  iscritto/a e frequentante nell’a.s. 2019/2020 la classe " +
            this.elements.classeAllievo +
            " e beneficiario dell'attività di Tirocinio Estivo presso codesta struttura Ospitante nel periodo compreso dal " +
            this.elements.dataInizioPeriodo +
            " al " +
            this.elements.dataFinePeriodo +
            " per complessive ore " +
            this.elements.totaleOre +
            " come riportato sul Registro delle presenze giornaliere,",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text: "ha svolto",
          alignment: "center",
          bold: true,
          margin: [0, 0, 0, 5],
          fontSize: 10
        },
        {
          text:
            "le attività previste dal Piano di Orientamento sviluppando le competenze sotto elencate e raggiungendo, nei vari ambiti, i livelli seguenti:",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          table: {
            widths: [150, "*"],
            body: [
              [
                {
                  text:
                    "Descrizione attività / compiti affidati al tirocinante",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoUnoArray[0] +
                      " ) Affiancamento in attività di progettazione/verifica",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoUnoArray[1] +
                      " ) Affiancamento in attività di produzione/organizzazione",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoUnoArray[2] +
                      " ) Affiancamento in attività di installazione/cantiere",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoUnoArray[3] +
                      " ) Affiancamento in attività di amministrazione",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Competenze tecnico-professionali ",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoDueArray[0] +
                      " ) Apprezzabili, degne di nota",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoDueArray[1] +
                      " ) Adeguate, accettabili",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoDueArray[2] +
                      " ) Sufficienti anche se migliorabili",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " + this.gruppoDueArray[3] + " ) Ancora da sviluppare",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Competenze di natura organizzativa",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoTreArray[0] +
                      " ) Apprezzabili, degne di nota",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoTreArray[1] +
                      " ) Adeguate, accettabili",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoTreArray[2] +
                      " ) Sufficienti anche se migliorabili",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " + this.gruppoTreArray[3] + " ) Ancora da sviluppare",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Competenze informatiche",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoQuattroArray[0] +
                      " ) Apprezzabili, degne di nota",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoQuattroArray[1] +
                      " ) Adeguate, accettabili",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoQuattroArray[2] +
                      " ) Sufficienti anche se migliorabili",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoQuattroArray[3] +
                      " ) Ancora da sviluppare",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Competenze linguistiche",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoCinqueArray[0] +
                      " ) Apprezzabili, degne di nota",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoCinqueArray[1] +
                      " ) Adeguate, accettabili",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoCinqueArray[2] +
                      " ) Sufficienti anche se migliorabili",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoCinqueArray[3] +
                      " ) Ancora da sviluppare",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Puntualità e frequenza",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoSeiArray[0] +
                      " ) Sempre presente e puntuale",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoSeiArray[1] +
                      " ) Assenze e ritardi accettabili ",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoSeiArray[2] +
                      " ) Assenze e ritardi frequenti",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoSeiArray[3] +
                      " ) Assenze e ritardi eccessivi",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Interesse dimostrato",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoSetteArray[0] +
                      " ) Ottimo, propositivo",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoSetteArray[1] +
                      " ) Buono, partecipativo",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoSetteArray[2] +
                      " ) Sufficiente, interessato",
                    style: "tableText"
                  },
                  {
                    text: "( " + this.gruppoSetteArray[3] + " ) Inadeguato",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Partecipazione all'attività",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoOttoArray[0] +
                      " ) Attività svolte in parziale autonomia ",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoOttoArray[1] +
                      " ) Collaborazione attiva ",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " + this.gruppoOttoArray[2] + " ) Assistenza attiva",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoOttoArray[3] +
                      " ) Affiancamento passivo",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Collaborazione, integrazione e relazioni di gruppo",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoNoveArray[0] +
                      " ) Rafforza il gruppo, propone",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoNoveArray[1] +
                      " ) Accetta il gruppo, collabora",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoNoveArray[2] +
                      " ) Preferisce lavorare individualmente",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoNoveArray[3] +
                      " ) Rifiuta il lavoro in equipe",
                    style: "tableText"
                  }
                ]
              ],
              [
                {
                  text: "Abbigliamento e linguaggio adottati",
                  style: "tableTitle"
                },
                [
                  {
                    text:
                      "( " +
                      this.gruppoDieciArray[0] +
                      " ) Coerente, tecnico, preciso ",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoDieciArray[1] +
                      " ) Adeguato, comprensibile, corretto",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoDieciArray[2] +
                      " ) Discutibile, nebuloso, poco appropriato",
                    style: "tableText"
                  },
                  {
                    text:
                      "( " +
                      this.gruppoDieciArray[3] +
                      " ) Non adeguato, poco rispettoso",
                    style: "tableText"
                  }
                ]
              ]
            ]
          }
        },
        {
          text: "Eventuali altre osservazioni: " + this.elements.noteAggiuntive,
          style: "bodyText",
          margin: [0, 5, 0, 5]
          // pageBreak: "before"
        },
        {
          text:
            "Data: " +
            this.elements.dataAttestato +
            " lì " +
            this.elements.luogoAttestato,
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text: this.elements.tutorAzienda,
          alignment: "right",
          style: "bodyText",
          bold: true
        },
        {
          image: this.elements.firmaTutorAzienda,
          width: 200,
          alignment: "right"
        },
        {
          text: "(firma per " + this.elements.denominazioneAzienda + ")",
          alignment: "right",
          style: "bodyText"
        }
        // {
        //   text:
        //     "Si ricorda che nei confronti del tirocinante l’Azienda è tenuta ad acquisire, previa adeguata informativa, il consenso al trattamento e alla comunicazione dei dati personali ai sensi di quanto previsto dall’art. 13 del D. Lgs. 196/2003 e all’art. 13 GDPR 679/16.",
        //   style: "bodyText",
        //   margin: [0, 5, 0, 0],
        //   italics: true
        // }
      ],
      styles: {
        bodyText: {
          fontSize: 8,
          justified: true
        },
        tableTitle: {
          fontSize: 8,
          bold: "true",
          alignment: "right"
        },
        tableText: {
          fontSize: 8
        },
        bodyTextHighlight: {
          fontSize: 10,
          justified: true,
          background: "yellow"
        }
      }
    };
    const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.id = "pdfPreview";
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  async parseValutazioni() {
    this.gruppoUnoArray = this.createValArray(this.elements.gruppoUno);
    this.gruppoDueArray = this.createValArray(this.elements.gruppoDue);
    this.gruppoTreArray = this.createValArray(this.elements.gruppoTre);
    this.gruppoQuattroArray = this.createValArray(this.elements.gruppoQuattro);
    this.gruppoCinqueArray = this.createValArray(this.elements.gruppoCinque);
    this.gruppoSeiArray = this.createValArray(this.elements.gruppoSei);
    this.gruppoSetteArray = this.createValArray(this.elements.gruppoSette);
    this.gruppoOttoArray = this.createValArray(this.elements.gruppoOtto);
    this.gruppoNoveArray = this.createValArray(this.elements.gruppoNove);
    this.gruppoDieciArray = this.createValArray(this.elements.gruppoDieci);
  }

  createValArray(voto: number): string[] {
    var valArray: string[] = [];
    for (let i = 0; i < 4; i++) {
      if (i === voto) {
        valArray.push("X");
      } else {
        valArray.push("");
      }
    }
    return valArray;
  }

  created() {
    this.parseValutazioni().then(() => {
      this.createDoc();
    });
  }
}
